export const fileTypes = {
    folder: require('../assets/picture/icon/format/have_folder_icon@2x.png'),
    mp3: require('../assets/picture/icon/format/MP3_music_icon@2x.png'),
    dcm: require('../assets/picture/icon/format/DCM_brain_icon@2x.png'),
    doc: require('../assets/picture/icon/format/DOC_document_icon@2x.png'),
    docx: require('../assets/picture/icon/format/DOCX_document_icon@2x.png'),
    flv: require('../assets/picture/icon/format/FLV_video_icon@2x.png'),
    ima: require('../assets/picture/icon/format/IMA_brain_icon@2x.png'),
    iso: require('../assets/picture/icon/format/ISO_system_icon@2x.png'),
    jpg: require('../assets/picture/icon/format/JPG_picture_icon@2x.png'),
    jpeg: require('../assets/picture/icon/format/JPG_picture_icon@2x.png'),
    m: require('../assets/picture/icon/format/M_document_icon@2x.png'),
    mp4: require('../assets/picture/icon/format/MP4_video_icon@2x.png'),
    pdf: require('../assets/picture/icon/format/PDF_picture_icon@2x.png'),
    png: require('../assets/picture/icon/format/PNG_picture_icon@2x.png'),
    ppt: require('../assets/picture/icon/format/PPT_document_icon@2x.png'),
    pptx: require('../assets/picture/icon/format/PPTX_document_icon@2x.png'),
    py: require('../assets/picture/icon/format/PY_document_icon@2x.png'),
    rar: require('../assets/picture/icon/format/RAR_system_icon@2x.png'),
    rmvb: require('../assets/picture/icon/format/RMVB_video_icon@2x.png'),
    swf: require('../assets/picture/icon/format/SWF_picture_icon@2x.png'),
    tar: require('../assets/picture/icon/format/TAR_system_icon@2x.png'),
    tiff: require('../assets/picture/icon/format/TIFF_picture_icon@2x.png'),
    txt: require('../assets/picture/icon/format/TXT_document_icon@2x.png'),
    wma: require('../assets/picture/icon/format/WMA_music_icon@2x.png'),
    xls: require('../assets/picture/icon/format/XLS_document_icon@2x.png'),
    xlsx: require('../assets/picture/icon/format/XLSX_document_icon@2x.png'),
    zip: require('../assets/picture/icon/format/ZIP_system_icon@2x.png'),
    default: require('../assets/picture/icon/format/default_document_icon@2x.png'),
    wen: require('../assets/picture/icon/format/default_wen_icon.png'),
    system: require('../assets/picture/icon/format/default_system_icon@2x.png'),
}

export function getFileSize(fileByte) {
    var fileSizeByte = fileByte;
    var fileSizeMsg = "";
    if (fileSizeByte < 1048576) fileSizeMsg = (fileSizeByte / 1024).toFixed(2) + "KB";
    else if (fileSizeByte == 1048576) fileSizeMsg = "1MB";
    else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) fileSizeMsg = (fileSizeByte / (1024 * 1024)).toFixed(2) + "MB";
    else if (fileSizeByte > 1048576 && fileSizeByte == 1073741824) fileSizeMsg = "1GB";
    else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) fileSizeMsg = (fileSizeByte / (1024 * 1024 * 1024)).toFixed(2) + "GB";
    else fileSizeMsg = "文件超过1TB";
    return fileSizeMsg;
}